const { translateString } = window.BAO.Utils

class VimeoEmbed extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.onLoad = this.onLoad.bind(this)
    this.listeners.add(document, 'DOMContentLoaded', this.onLoad)
  }

  onLoad () {
    if (this.isVisible) {
      this.load()
    } else {
      this.observer = new ResizeObserver(() => this.tryToLoad())
      this.observer.observe(this)
    }
  }

  tryToLoad () {
    if (this.isVisible) {
      this.load()
    }
  }

  load () {
    const video = translateString(this.iFrameTemplate, {
      src: this.getAttribute('src'),
    })
    this.els.container.element.insertAdjacentHTML('beforeend', video)

    this.observer?.disconnect()
  }

  /**
   * @see https://github.com/jquery/jquery/blob/main/src/css/hiddenVisibleSelectors.js
   */
  get isVisible () {
    return Boolean(
      this.offsetWidth || this.offsetHeight || this.getClientRects().length,
    )
  }

  get iFrameTemplate () {
    return `
      <iframe
        class="vid-Vimeo_Iframe"
        style="position: absolute; inset: 0 0 0 0; height: 100%; width: 100%;"
        frameborder="0"
        allow="autoplay; fullscreen; picture-in-picture"
        allowfullscreen
        data-vimeo-embed-el="video"
        src="{{ src }}"
      ></iframe>
    `.trim()
  }
}

if (!customElements.get('vimeo-embed')) {
  customElements.define('vimeo-embed', VimeoEmbed)
}
